import { createModalPlaceholder } from '../bootstrap-helpers'

export const gFormsConfirmation = (() => {
	const confirmation = document.querySelector('.gform_confirmation_wrapper') || false
	const form = confirmation ? confirmation.closest('.loveli-form-container') : false

	if (!form) return

	form.className = 'loveli-form-container'
	const modal = createModalPlaceholder('form-confirmation-modal', { modalFooter: true })
	modal._element.querySelector('.modal-body').append(form)

	modal.show()
})()
